import axios from 'axios';

export function getAllLicensesService() {
    return () => axios.get(`/licenses`);
}

export function listFaciltyLicensesService(facilityId) {
    return () => axios.get(`/licenses/facility/${facilityId}`);
}
